import { render, staticRenderFns } from "./OctUserForm.vue?vue&type=template&id=5d9e734c&scoped=true&"
import script from "./OctUserForm.vue?vue&type=script&lang=js&"
export * from "./OctUserForm.vue?vue&type=script&lang=js&"
import style0 from "./OctUserForm.vue?vue&type=style&index=0&id=5d9e734c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e734c",
  null
  
)

export default component.exports